import { ExternalLink } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import { buildServerPackagingInstruction } from "../../Instructions";
import { CommonTextForOctopusCli, CommonBuildServerPackagingTextForIntegration, CommonTextForJavaSample } from "../CommonRegistrationText";
export const BuildServerPackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging Java applications from build servers, we recommend using the <ExternalLink href={"cli"}>Octopus CLI</ExternalLink>.
        </p>
        {CommonTextForJavaSample}
        {CommonTextForOctopusCli}
        {CommonBuildServerPackagingTextForIntegration}
        <p>
            The <ExternalLink href="GuidesJava">Java guides</ExternalLink> provide step by step instructions for deploying Java applications.
        </p>
    </div>);
BuildServerPackaging.displayName = "BuildServerPackaging"
export default buildServerPackagingInstruction(() => <BuildServerPackaging />);
